export default __webpack_public_path__ + "static/featuredImage-60cfc6415f4270852127e1e5f6e4f4fa.webp";